// should probably just use moment
export function convertToGMTOffset(offset: number): string {
  const hours = offset * -1 / 60;
  const minutes = Math.abs(offset) % 60;
  return `GMT${offset > 0 ? '-' : '+'}${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
}
